<template>
  <div id="create">
    <v-container fluid id="anpr-listing-view" class="px-2">
      <v-data-table
        :mobile-breakpoint="mobilebreakpoint"
        :headers="headers"
        :items="listingData"
        :items-per-page="10"
        :search="search"
        class="elevation-4 mt-2"
        :loading="tableLoading"
        loading-text="Loading... Please wait"
      >
        <template v-slot:item.lcT_DT="{ item }">
          <span>{{ formatDate(item.lcT_DT, "DD-MMM-YY") }}</span>
        </template>
        <template v-slot:item.tP_NAME="{ item }">
          <span v-html="item.tP_NAME"></span>
        </template>
        <template v-slot:item.qname="{ item }">
          <span v-if="item.qname === 'Not Attempted'">{{item.qname}}</span>
          <a v-else
            
            @click="downloadfile(item.qname, 'Q')"
          >Download</a>
        </template>
        <template v-slot:item.aname="{ item }">
          <span v-if="item.aname === 'Not Attempted'">{{item.aname}}</span>
          <a v-else
            
            @click="downloadfile(item.aname, 'A')"
          >Download</a>
        </template>
      </v-data-table>

      <vconfirm
        :confirmOption="confirmBox"
        @isConfirm="isConfirm"
        :dialogConfirm="dialogConfirm"
        :confirmLoading="confirmLoading"
      >
      </vconfirm>
    </v-container>
  </div>
</template>
<style scoped>
.v-data-table {
  max-width: 100%;
}
.total {
  background-color: lightgray;
  text-align: right;
  padding-right: 1em;
}

.subtotal {
  background-color: yellow;
}
</style>
<script>
import axios from "axios";
import { get } from "vuex-pathify";

import vconfirm from "@/components/v-confirm";
import download from "downloadjs";
import moment from "moment";
import { showSnackbar } from "../util/globalActions";
export default {
  name: "TestPaperView",
  components: { vconfirm },

  data: () => ({
    tab: null,
    validEdit: false,
    switchmobilebreakpoint: false,
    mobilebreakpoint: "200",
    confirmBox: {
      message: "",
      okCaption: "OK",
      cancelCaption: "Cancel",
      data: "",
    },
    dialogConfirm: false,
    confirmLoading: false,
    isConfirm: false,
    width: 700,
    tableLoading: false,
    loadingprofessor: false,
    valid: false,
    modal: false,
    fromDate: null,
    toDate: null,
    search: "",
    listingData: [],
    message: "",
    professors: [],
    snackbar: false,
    reqRules: [(v) => !!v || "Field is required"],
    professor_id: null,
    headers: [],
  }),
  created() {
    this.headers = [];
    this.showData();
  },
  mounted() {},
  computed: {
    apiUrl: get("app/apiUrl"),
    userid: get("user/id"),
    menuid: get("user/menuid"),
    selecteduserid: get("app/selecteduserid"),
  },
  watch: {
    switchmobilebreakpoint: function(value) {
      if (value === true) this.mobilebreakpoint = "600";
      else this.mobilebreakpoint = "200";
    },
  },
  methods: {
    downloadfile(fileName, fileType) {
      axios
        .get(
          this.apiUrl +
            "api/Download/GetPDF/" +
            fileName +
            "/" +
            fileType,
          {
            
            responseType: "blob", // had to add this one here
          }
        )
        .then((response) => {
          const content = response.headers["content-type"];
          download(response.data, fileName, content);
        })
        .catch((error) => console.log(error));
    },
    formatDate(value, dateFormat) {
      if (!value) return "Not Found";
      return moment(String(value)).format(dateFormat);
    },
    getParameter() {
      const self = this;
      const fromDate = new Date(self.fromDate).toJSON();
      const toDate = new Date(self.toDate).toJSON();
      const data = {
        fromDate: fromDate,
        uptoDate: toDate,
      };
      return data;
    },

    showData() {
      const self = this;
      self.headers = [];
      self.headers.push({
        text: "Test Date",
        value: "lcT_DT",
        width: "100px",
      });
      self.headers.push({
        text: "Test ID",
        value: "exM_ID",
        width: "150px",
      });
      self.headers.push({
        text: "Subject",
        value: "suB_NAME",
        width: "100px",
      });
      self.headers.push({
        text: "Topic",
        value: "tP_NAME",
        width: "300px",
      });
      self.headers.push({
        text: "Test Type",
        value: "tsT_NAME",
        width: "100px",
      });
      self.headers.push({
        text: "Question Paper",
        value: "qname",
        width: "100px",
      });
      self.headers.push({
        text: "Model Answer",
        value: "aname",
        width: "100px",
      });
      self.selectedfromdate = self.fromDate;
      self.selectedtodate = self.toDate;

      self.tableLoading = true;

      axios({
        url: self.apiUrl + "api/Download/GetTestPaper",
        method: "GET",
        responseType: "json",
      })
        .then(function(res) {
          self.listingData = res.data;
          
          self.tableLoading = false;
          self.hiddenPDF = false;
        })
        .catch(function(err) {
          self.hiddenPDF = true;
          self.tableLoading = false;
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },

    row_classes(item) {
      return item.rowcolor.toLowerCase();
    },
  },
};
</script>
